import React from "react";
import { Card } from "@/components/ui/card";
import { ShieldCheck, Wrench, Clock, BadgeEuro } from "lucide-react";

const WHY_ICONS = [BadgeEuro, ShieldCheck, Clock, Wrench];

export function HomeWhyUs({ t }) {
  const items = t("home.why_us_items") || [];
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-14">
      <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">{t("home.why_us_title")}</h2>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((w, i) => {
          const Icon = WHY_ICONS[i] || ShieldCheck;
          return (
            <Card key={`why-${w.t}`} className="p-4 card-hover">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[hsl(var(--brand-aqua))]/10 text-[hsl(var(--brand-aqua))]">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-3 text-base font-semibold text-[hsl(var(--brand-navy))]">{w.t}</h3>
              <p className="mt-1 text-sm text-[hsl(var(--muted-foreground))]">{w.d}</p>
            </Card>
          );
        })}
      </div>
    </section>
  );
}

export default HomeWhyUs;
